// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/aerodrome-terminology.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/aerodrome-terminology/aerodrome-surface-areas.js';
import g1 from '../lessons/air-law/aerodrome-terminology/aerodrome-terminology.js';

mount([g0, g1]);
